// extracted by mini-css-extract-plugin
export default {"left-split":"HomePromises_left-split__bIIXS","see-all-promise":"HomePromises_see-all-promise__VHdsv"};